// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"LotteryDrawButton_actionButton__tCRk1"};